<template>
  <div>
    <v-row>
      <v-col align="center">
        <v-skeleton-loader
          class="mb-2 mt-2 resource-loader"
          :type="headingSkeletonLayout"
          :loading="_loading"
          transition-group="scale-transition"
        >
          <h4 class="display-1">
            <Dictionary module="permissions" string="title" />
          </h4>
          <p class="mb-5 body-1">
            <Dictionary module="permissions" string="subtitle" />
          </p>
        </v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row class="mb-4">
      <v-col cols="12">
        <ClientPhotoPermissionList />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ClientPhotoPermissionList from './../components/Permissions/ClientPhotoPermissionList';
export default {
  name: 'ParentPermissionsPage',
  components: {
    ClientPhotoPermissionList,
  },
  computed: {
    ...mapGetters(['_loading']),
  },
  data() {
    return {
      headingSkeletonLayout: 'heading, sentences',
      cardSkeletonLayout: 'list-item-avatar-two-line@3',
    };
  },
};
</script>

<style scoped>
.v-list {
  background: transparent;
}
</style>
